var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6038 11.7547H10.0566V10.6226H12.6038C13.8522 10.6226 14.8679 9.60689 14.8679 8.35849C14.8679 7.1817 13.9849 6.21292 12.8141 6.10538L12.3459 6.06236L12.3026 5.59425C12.1187 3.62047 10.4842 2.13208 8.5 2.13208C6.51575 2.13208 4.88132 3.62047 4.69736 5.59396L4.65406 6.06208L4.18594 6.10509C3.01509 6.21292 2.13208 7.1817 2.13208 8.35849C2.13208 9.60689 3.14783 10.6226 4.39623 10.6226H6.66038V11.7547H4.39623C2.52349 11.7547 1 10.2312 1 8.35849C1 6.74783 2.10292 5.3967 3.63066 5.04943C4.05632 2.71198 6.07708 1 8.5 1C10.9229 1 12.9437 2.71198 13.3693 5.04943C14.8971 5.3967 16 6.74783 16 8.35849C16 10.2312 14.4765 11.7547 12.6038 11.7547Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.225
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.92504 7.22656H7.79297V13.736H8.92504V7.22656Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.225
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.93883 9.04331L8.35788 7.46265L6.77694 9.04331L5.97656 8.24293L8.35788 5.86133L10.7392 8.24293L9.93883 9.04331Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.225
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.6ac75ab69716ee3a6174000fe83ee029.svg";
export { ForwardRef as ReactComponent };